<script context="module">
  import { writable } from "svelte/store";
  import { get_ip_address_prefix } from "./Urls.svelte";
  import { addToast, toasts } from "./components/store";

  let auth = "";
  let login_failed = false;
  export const access = writable(0);
  export const refresh = writable(0);
  let const_access;
  let const_refresh;

  const ip_address_prefix = get_ip_address_prefix;
  let get_registerURLrefresh_url = ip_address_prefix + "api/token/refresh/";

  const unsubscribe_access = access.subscribe((value) => {
    const_access = value;
  });

  const unsubscribe_refresh = refresh.subscribe((value) => {
    const_refresh = value;
  });

  export async function createByUrl(url, dict) {
    //console.log(dict);
    var opt = buildOptionsWithDict(dict);
    var response = await fetch(url, opt);

    //console.log('Response:');
    //console.log(response);
    if (!response.ok) {
      //console.log('Respones Error:');
      //console.log(response);
      refresh_token();
      return 0;
    }

    return response;
  }

  export async function createPutByUrl(url, dict) {
    //console.log(dict);
    var opt = buildPutOptionsWithDict(dict);
    var response = await fetch(url, opt);
    if (!response.ok) {
      refresh_token();
      return 0;
    }
    return response;
  }

  export function createByUrlWithThenWithoutRefresh(url, dict) {
    var opt = buildOptionsWithDict(dict);
    var response = fetch(url, opt);
    return response;
  }

  export function updateByUrlWithThenWithoutRefresh(url, dict) {
    console.log("url: ", url);
    var opt = buildUpdateOptionsWithDict(dict);
    var response = fetch(url, opt);
    return response;
  }

  export async function updateByUrl(url, dict) {
    if (access == "") {
      return 0;
    }
    var opt = buildUpdateOptionsWithDict(dict);
    var response = await fetch(url, opt);
    if (!response.ok) {
      refresh_token();
      return 0;
    }
    return response;
  }

  export async function deleteByUrl(url) {
    if (access == "") {
      return 0;
    }
    let response = await fetch(url, buildDeleteOptions());
    if (!response.ok) {
      refresh_token();
      return 0;
    }
    let json_data = await response.json();
    return json_data;
  }

  export async function getByUrl(url) {
    if (access == "") {
      return 0;
    }
    let response = await fetch(url, buildOptions());
    if (!response.ok) {
      refresh_token();
      return 0;
    }
    let json_data = await response.json();
    return json_data;
  }

  export async function getByUrlWithThen(url) {
    if (const_access == "") {
      return 0;
    }
    //console.log('const_access: ', const_access);
    //console.log('buildOptions: ', buildOptions());
    return fetch(url, buildOptions()).catch(function () {
      //console.log('Try to refresh token');
      refresh_token();
      return 0;
    });
  }

  export function createByUrlWithThen(url, dict) {
    var opt = buildOptionsWithDict(dict);
    var response = fetch(url, opt);
    response.catch((error) => {
      refresh_token();
    });
    return response;
  }

  export async function authenticate(register_url, options) {
    console.log("register_url", register_url);
    //console.log('options', options);

    try {
      const response = await fetch(register_url, options);
      // console.log('response: ', response);
      if (!response.ok) {
        console.log("response not ok");
        //refresh_token();
        login_failed = true;
        addToast({
          message: "Login failed. Please check your username or password and try again.",
          type: "error",
          dismissible: true,
          timeout: 3000,
        });
        login_isOpen = true;
        return 0;
      }
      //console.log('Try Authenticate...');
      let data = await response.json();
      //console.log('data', data);
      if (data["access"]) {
        access.set(data["access"]);
        refresh.set(data["refresh"]);
        console.log("Authenticated!");
        addToast({ message: "Login success. Loading data...", type: "success", dismissible: true, timeout: 10000 });
        return true;
      } else {
        console.log("Not Authenticated!");
        login_failed = true;
        addToast({
          message: "Login failed. Please check your username or password and try again.",
          type: "error",
          dismissible: true,
          timeout: 3000,
        });
        login_isOpen = true;
        return false;
      }
    } catch (e) {
      if (!login_failed) {
        login_failed = true;
        addToast({
          message: "Login failed due to server connection error. Please try again.",
          type: "error",
          dismissible: true,
          timeout: 3000,
        });
      }
      login_isOpen = true;
      console.log("catch", e);
      console.log("Not Authenticated!");
      throw new 400();
      return;
    }
  }

  export async function refresh_token() {
    //console.log('in refresh token function');
    let options_refresh = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh: const_refresh }),
    };
    //console.log(options_refresh);
    const response = await fetch(get_registerURLrefresh_url, options_refresh);
    let data = await response.json();
    access.set(data["access"]);
    // refresh.set(data["refresh"]);
    // Anscheinend bekommt man beim refreshen keinen neuen refresh Token
    //console.log('New Access:');
    //console.log(const_access);
    //console.log('New Refresh:');
    //console.log(const_refresh);
    //console.log('Authenticated!');
    //console.log(access);
    return true;
  }

  function getCookie(name) {
    if (!document.cookie) {
      return null;
    }

    const xsrfCookies = document.cookie
      .split(";")
      .map((c) => c.trim())
      .filter((c) => c.startsWith(name + "="));

    if (xsrfCookies.length === 0) {
      return null;
    }
    return decodeURIComponent(xsrfCookies[0].split("=")[1]);
  }

  function buildOptions() {
    //console.log('const_access', const_access);
    let opt = {
      headers: {
        Authorization: "Bearer " + const_access,
        accept: "application/json",
        "Content-Type": "application/json",
      },
      mode: "cors",
    };
    // 'X-CSRF-TOKEN': getCookie('CSRF-TOKEN'),
    return opt;
  }

  function buildDeleteOptions() {
    let opt = {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + const_access,
        accept: "application/json",
        "Content-Type": "application/json",
      },
      mode: "cors",
    };
    // 'X-CSRF-TOKEN': getCookie('CSRF-TOKEN'),
    return opt;
  }

  function buildPutOptionsWithDict(dict) {
    let opt = {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + const_access,
        accept: "application/json",
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(dict),
    };
    // 'X-CSRF-TOKEN': getCookie('CSRF-TOKEN'),
    return opt;
  }

  function buildOptionsWithDict(dict) {
    let opt = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + const_access,
        accept: "application/json",
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(dict),
    };
    // 'X-CSRF-TOKEN': getCookie('CSRF-TOKEN'),
    return opt;
  }

  function buildUpdateOptionsWithDict(dict) {
    let opt = {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + const_access,
        accept: "application/json",
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(dict),
    };
    // 'X-CSRF-TOKEN': getCookie('CSRF-TOKEN'),
    return opt;
  }

  function json2array(json) {
    var result = [];
    var keys = Object.keys(json);
    keys.forEach(function (key) {
      result.push(json[key]);
    });
    return result;
  }

  export async function get_appointments() {
    let tmp_appointments_json_data = getRequest();
    await tmp_appointments_json_data;
    return parseAppointmentsJsonData(tmp_appointments_json_data);
  }

  function parseAppointmentsJsonData(appointments_json_data_tmp) {
    for (let i = 0; i < appointments_json_data_tmp.length; i++) {
      let entry = appointments_json_data_tmp[i];
      var date_start = moment(entry.appointment_date_start).format("DD-MM-YYYY");
      // let date_start = Date.parse();
      let date_end = moment(entry.appointment_date_end).format("DD-MM-YYYY");
      let start_time = moment(entry.appointment_date_start).format("hh:mm");
      let end_time = moment(entry.appointment_date_end).format("hh:mm");

      appointments_json_data_tmp[i].appointment_date_start = date_start;
      appointments_json_data_tmp[i].appointment_date_end = date_end;
      appointments_json_data_tmp[i].appointment_date_start_time = start_time;
      appointments_json_data_tmp[i].appointment_date_end_time = end_time;
    }
    return appointments_json_data_tmp;
  }

  async function getRequest() {
    appointments_json_data = await getByUrl(get_appointments_url());
    return true;
  }
</script>
